import React, { useEffect, useState } from "react";
import "./style.scss"
import InnerImageZoom from "react-inner-image-zoom";
import { MdFormatListBulletedAdd } from "react-icons/md";
import devil_cute_img from "assets/users/devil_cute.jpg"
import snowman_img from "assets/users/snowman_cute.png"
import { Rating } from "@mui/material";
import { FaPencilAlt } from "react-icons/fa";
import { useParams } from "react-router-dom";
import { getBookByID } from "services/user/bookService";
import { PacmanLoader } from "react-spinners";
import { Formatter } from "utils/formatter";
import { FormatDate } from "utils/formatDate";
import { getRatingPercent, getReviewsForBook } from "services/user/reviewService";

const BookDetail = () => {
    const { id } = useParams(); // Lấy id từ URL
    const [book, setBook] = useState()
    const [reviews, setReviews] = useState([]);
    const [ratingPercent, setRatingPercent] = useState([]);


    useEffect(() => {
        const fetchBookDetails = async () => {
          const response = await getBookByID(id);
          setBook(response.data);
        };
    
        fetchBookDetails();
    }, [id]);
    
    const fetchReviewsForBook = async () => {
        const response = await getReviewsForBook(id, 0)
        // setTotalPage(response.data.page.totalPages)
        return response.data.content
    }
    
      // lấy phần trăm rating
    const fetchRatingPercent = async () => {
        const response = await getRatingPercent(id)
        return response.data
    }

    useEffect(() => {
        const fetchReview = async () => {
            try {
                const [response1, response2] = await Promise.all([fetchReviewsForBook(), fetchRatingPercent()]);
                
                setReviews(response1)
                setRatingPercent(response2)
            
            } 
            catch (error) {
                console.log("fetchReview", error)
            }
        }
        fetchReview();
    })



    if (!book || !reviews) {
        return (
          <section className="productDetails section d-flex justify-content-center">
            <PacmanLoader color="#5E2E86" />
          </section>
        );
    }
    return (
        <section className="bookDetails section">
            <div className="card border-0 p-4 mb-5">
                <div className="row">
                    <div className="col-lg-4 col-md-12">
                        <div className="productZoom">
                            <div>
                            <InnerImageZoom
                                src={book.imageLink}
                                zoomType="hover"
                                zoomScale={1}
                                alt="Book Cover"
                            />
                            </div>
                        </div>
                    </div>
                
                    <div className="col-lg-8 col-md-12 ps-5">
                        <h4>{book.title}</h4>
                        <div className="d-flex mt-1">
                            <span style={{fontSize: '18px'}} className="curPrice text-danger me-3">
                                {Formatter(book.discountedPrice)}
                            </span>
                            <span style={{fontSize: '16px'}} className="oriPrice">
                                {Formatter(book.originalPrice)}
                            </span>
                        </div>

                        <div className="bookInfos mt-2">
                            <div className="row mb-2">
                                <div className="col-md-4 d-flex align-items-center">
                                    <span className="name">Thể loại</span>
                                </div>

                                <div className="col-md-8">
                                    : <span style={{fontSize: '14px', paddingLeft: '10px'}}>{book.category}</span>
                                </div>
                            </div>

                            <div className="row mb-2">
                                <div className="col-md-4 d-flex align-items-center">
                                    <span className="name">Tác giả</span>
                                </div>

                                <div className="col-md-8">
                                    : <span style={{fontSize: '14px', paddingLeft: '10px'}}>
                                        {book.authors.map((author, index) => (
                                            <span key={index}>
                                                {author.name}
                                            {index < book.authors.length - 1 && ", "}
                                            </span>
                                        ))}
                                    </span>
                                </div>
                            </div>

                            <div className="row mb-2">
                                <div className="col-md-4 d-flex align-items-center">
                                    <span className="name">Đối tượng</span>
                                </div>

                                <div className="col-md-8">
                                    : <span style={{fontSize: '14px', paddingLeft: '10px'}}>
                                        {book.targets.map((target) => target.name).join(", ")}
                                    </span>
                                </div>
                            </div>

                            <div className="row mb-2">
                                <div className="col-md-4 d-flex align-items-center">
                                    <span className="name">Nhà xuất bản</span>
                                </div>

                             <div className="col-md-8">
                                    : <span style={{fontSize: '14px', paddingLeft: '10px'}}>
                                        {book.publisher}
                                    </span>
                                </div>
                            </div>

                            <div className="row mb-2">
                                <div className="col-md-4 d-flex align-items-center">
                                    <span className="name">Lượt bán</span>
                                </div>

                                <div className="col-md-8">
                                    : <span style={{fontSize: '14px', paddingLeft: '10px'}}>
                                        {book.soldQuantity}
                                    </span>
                                </div>
                            </div>

                            <div className="row mb-2">
                                <div className="col-md-4 d-flex align-items-center">
                                    <span className="name">Kho</span>
                                </div>

                                <div className="col-md-8">
                                    : <span style={{fontSize: '14px', paddingLeft: '10px'}}>
                                        {book.availableQuantity}
                                    </span>
                                </div>
                            </div>

                            <div className="row mb-2">
                                <div className="col-md-4 d-flex align-items-center">
                                    <span className="name">Số trang</span>
                                </div>

                                <div className="col-md-8">
                                    : <span style={{fontSize: '14px', paddingLeft: '10px'}}>
                                        {book.pages}
                                    </span>
                                </div>
                            </div>

                            <div className="row mb-2">
                                <div className="col-md-4 d-flex align-items-center">
                                    <span className="name">Khuôn khổ</span>
                                </div>

                                <div className="col-md-8">
                                    : <span style={{fontSize: '14px', paddingLeft: '10px'}}>
                                        {book.dimension}
                                    </span>
                                </div>
                            </div>

                            <div className="row mb-2">
                                <div className="col-md-4 d-flex align-items-center">
                                    <span className="name">Định dạng</span>
                                </div>

                                <div className="col-md-8">
                                    : <span style={{fontSize: '14px', paddingLeft: '10px'}}>
                                        {book.cover}
                                    </span>
                                </div>
                            </div>


                            {book.datePublish ? (
                                <div className="row mb-2">
                                    <div className="col-md-4 d-flex align-items-center">
                                        <span className="name">Ngày phát hành</span>
                                    </div>

                                <div className="col-md-8">
                                        : <span style={{fontSize: '14px', paddingLeft: '10px'}}>
                                            {FormatDate(book.datePublish)}
                                        </span>
                                    </div>
                                </div>
                                    
                        
                            ) : (
                                <div></div>
                            )}

                        </div>
                    </div>
                </div>

                <div className="mt-5">
                    <h4>Mô tả sản phẩm</h4>
                    <p style={{fontWeight: '400', fontSize: '15px', lineHeight: '25px'}}>{book.description}
                    </p>

                    <h4 className="mt-4 mb-3">Đánh giá</h4>
                    <div className="ratingSection d-flex">
                        <div className="col-lg-6">
                            <div className="ratingRow d-flex align-items-center justify-content-center">
                                <span className="col1">5 sao</span>
                                <span className="col2">
                                    <div className="progress" style={{height: '5px'}}>
                                        <div className="progress-bar" style={{ width: `${ratingPercent?.[4]?.percent ?? 0}%`, background: "orange" }}>
                                        </div>

                                    </div>
                                </span>
                                {/* <span className="col3">(22)</span> */}

                            </div>

                            <div className="ratingRow d-flex align-items-center justify-content-center">
                                <span className="col1">4 sao</span>
                                <span className="col2">
                                    <div className="progress" style={{height: '5px'}}>
                                        <div className="progress-bar" style={{ width: `${ratingPercent?.[3]?.percent ?? 0}%`, background: "orange" }}>

                                        </div>

                                    </div>
                                </span>
                                {/* <span className="col3">(22)</span> */}

                            </div>

                            <div className="ratingRow d-flex align-items-center justify-content-center">
                                <span className="col1">3 sao</span>
                                <span className="col2">
                                    <div className="progress" style={{height: '5px'}}>
                                        <div className="progress-bar" style={{ width: `${ratingPercent?.[2]?.percent ?? 0}%`, background: "orange" }}>

                                        </div>

                                    </div>
                                </span>
                                {/* <span className="col3">(22)</span> */}

                            </div>

                            <div className="ratingRow d-flex align-items-center justify-content-center">
                                <span className="col1">2 sao</span>
                                <span className="col2">
                                    <div className="progress" style={{height: '5px'}}>
                                        <div className="progress-bar" style={{ width: `${ratingPercent?.[1]?.percent ?? 0}%`, background: "orange" }}>

                                        </div>

                                    </div>
                                </span>
                                {/* <span className="col3">(22)</span> */}

                            </div>

                            <div className="ratingRow d-flex align-items-center justify-content-center">
                                <span className="col1">1 sao</span>
                                <span className="col2">
                                    <div className="progress" style={{height: '5px'}}>
                                        <div className="progress-bar" style={{ width: `${ratingPercent?.[0]?.percent ?? 0}%`, background: "orange" }}>

                                        </div>

                                    </div>
                                </span>
                                {/* <span className="col3">(22)</span> */}

                            </div>
                        </div>

                        <div className="col-lg-6 ">
                            <h4 className="d-flex justify-content-center">Tổng đánh giá ({book.reviewCount})</h4>
                            <h1 className="d-flex justify-content-center" style={{fontSize: '4rem', fontWeight: '700'}}>{book.rating}</h1>

                            <Rating
                                className="d-flex justify-content-center w-100"
                                name="half-rating-read"
                                defaultValue={book.rating}
                                precision={0.1}
                                readOnly
                            />
                        </div>
                    
                    </div>


                    <h4 className="mt-4 mb-3">Khách hàng đánh giá</h4>
                    {reviews && reviews.length > 0 ? (
                        reviews.map((review) => (
                            <div key={review.reviewID}>
                                <div className="card reviewsCard flex-row mb-3">
                                    <div className="image">
                                        <div className="rounded-circle">
                                            <img
                                                src={review.rating === 4 || review.rating === 5 ? snowman_img : devil_cute_img}
                                                alt="" loading="lazy"
                                            />
                                        </div>
                                        <span>{review.reviewer}</span>
                                    </div>

                                    <div className="info">
                                        <div className="d-flex align-items-center">
                                            <span className="datePublish">
                                            {FormatDate(review.dateReview)}
                                            </span>
                                            <div className="ps-3">
                                                <Rating
                                                    name="read-only"
                                                    value={review.rating}
                                                    precision={1}
                                                    readOnly
                                                    size="small"
                                                />
                                            </div>
                                        </div>
                                        <p style={{ fontSize: "15px" }}>
                                            {review.comment}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                      <div>Hiện không có đánh giá nào</div>
                    )}
                    
                </div>
            </div>
        </section>
    )
}

export default BookDetail;